import clsx from "clsx";
import styles from "./LoadingState.module.css";

interface LoadingStateProps {
  label?: string;
  fullScreen?: boolean;
  className?: string;
  skeletonRows?: number;
}

export function LoadingState({
  label = "Loading…",
  fullScreen,
  className,
  skeletonRows = 0,
}: LoadingStateProps) {
  if (skeletonRows > 0) {
    return (
      <div className={styles.skeletonWrap}>
        {Array.from({ length: skeletonRows }).map((_, idx) => (
          <div key={idx} className={styles.skeletonRow} />
        ))}
      </div>
    );
  }
  return (
    <div
      role="status"
      aria-live="polite"
      className={clsx(styles.root, fullScreen && styles.fullScreen, className)}
    >
      <div className={styles.spinner} aria-hidden />
      <div className={styles.label}>{label}</div>
    </div>
  );
}
